import React from 'react';
import { renderRoutes } from 'react-router-config';
import propTypes from 'prop-types';

export default function Root({ route }) {
  return (
    <MainContainer>
      {renderRoutes(route.routes)}
      <div style={{ flex: 1 }} />
      <Footer>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://kiper.com.br/wp-content/uploads/FAQ-Assembleia-Kiper-1.pdf"
        >
          Para maiores informações, consulte o FAQ
        </a>
      </Footer>
    </MainContainer>
  );
}

Root.propTypes = {
  route: propTypes.shape({ routes: propTypes.object }).isRequired,
};

const MainContainer = ({ children }) => (
  <div className="container d-flex flex-column" style={{ minHeight: '100vh' }}>
    {children}
  </div>
);

MainContainer.propTypes = {
  children: propTypes.node.isRequired,
};

const Footer = ({ children }) => <div className="w-100 mt-4 p-1 text-center border-top small">{children}</div>;

Footer.propTypes = {
  children: propTypes.node.isRequired,
};
